import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    constructor(private toastService: ToastrService) { }

    showStandard(title: string, text: string) {
        this.toastService.info(text, title, {
            timeOut: 5000,
            positionClass: 'toast-top-right',
            // closeButton: true,
        });
    }

    showSuccess(title: string, text: string) {
        this.toastService.success(text, title, {
            timeOut: 5000,
            positionClass: 'toast-top-right',
        });
    }

    showWarning(title: string, text: string) {
        this.toastService.warning(text, title, {
            timeOut: 5000,
            positionClass: 'toast-top-right',
        });
    }

    showError(title: string, text: string) {
        this.toastService.error(text, title, {
            timeOut: 5000,
            positionClass: 'toast-top-right',
        });
    }

    positionToast(position: string) {
        this.toastService.info('Welcome Back! This is a Toast Notification', '', {
            timeOut: 5000,
            positionClass: position,
            closeButton: true,
        });
    }

    durationToast(position: string) {
        this.toastService.info('Toast Duration 5s', '', {
            timeOut: 5000,
            positionClass: position,
            // closeButton: false,
        });
    }
}
